"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountingsListApiResponseSchema = void 0;
const zod_1 = require("zod");
const doctor_attending_1 = require("../doctor-attendings/doctor-attending");
const doctor_substitute_1 = require("../doctor-substitutes/doctor-substitute");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const office_1 = require("../offices/office");
const accouting_1 = require("./accouting");
exports.getAccountingsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(accouting_1.getAccountingApiEntitySchema).merge(zod_1.z.object({
    included: zod_1.z
        .array(zod_1.z.union([
        office_1.simpleOfficeApiSchema,
        doctor_attending_1.simpleDoctorAttendingApiSchema,
        doctor_substitute_1.simpleDoctorSubtituteApiSchema,
    ]))
        .optional()
        .default([]),
}));
